import * as React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';

const EarningsDisclaimer: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <HelmetProvider>
      <div>
        <Helmet>
          <title>Earnings & Affiliate Disclaimer | RoastMyListing.ai</title>
          <meta name="description" content="Earnings and Affiliate Disclaimer for RoastMyListing.ai" />
        </Helmet>
        
        {/* Header with logo */}
        <div style={{ 
          width: '100%', 
          backgroundColor: '#3b82f6',
          background: 'linear-gradient(135deg, #4f46e5 0%, #3b82f6 100%)',
          padding: '8px 0', 
          marginBottom: '2px',
          boxShadow: '0 1px 4px rgba(66, 133, 244, 0.2)'
        }}>
          <div style={{
            maxWidth: '1200px',
            margin: '0 auto',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '0 20px',
            gap: '4px' 
          }}>
            <div 
              onClick={() => navigate('/')}
              style={{ 
                cursor: 'pointer',
                display: 'inline-block',
                textAlign: 'center',
                marginBottom: '0'
              }}
            >
              <img 
                src="/logo.png" 
                alt="RoastMyListing.ai Logo"
                style={{ 
                  maxWidth: '300px', 
                  height: 'auto'
                }}
              />
            </div>
          </div>
        </div>
        
        {/* Main content */}
        <div style={{ 
          maxWidth: '900px', 
          margin: '40px auto', 
          padding: '0 20px',
          color: '#333',
          lineHeight: '1.6'
        }}>
          <h1 style={{ 
            fontSize: '2.5rem', 
            marginBottom: '30px',
            textAlign: 'center',
            color: '#1f2937'
          }}>
            Earnings & Affiliate Disclaimer
          </h1>
          
          <div style={{ marginBottom: '30px' }}>
            <p style={{ marginBottom: '15px' }}>
              <strong>Last Updated:</strong> March 21, 2025
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px', color: '#374151' }}>FTC Disclosure Compliance</h2>
            <p>
              This disclaimer is provided in accordance with the Federal Trade Commission's guidelines concerning the use of endorsements and testimonials in advertising.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px', color: '#374151' }}>Affiliate Relationships</h2>
            <p>
              Sellers Arena Inc. DBA Seller Synapse ("we," "our," or "us"), the operator of RoastMyListing.ai, is a participant in the Amazon Associates Program, an affiliate advertising program designed to provide a means for sites to earn advertising fees by advertising and linking to Amazon.com and affiliated sites.
            </p>
            <p>
              We may also participate in other affiliate marketing programs with other companies. This means that when you click on links to various websites from our site, we may earn a commission on any resulting sales or actions.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px', color: '#374151' }}>Affiliate Link Disclosure</h2>
            <p>
              Some of the links on RoastMyListing.ai are affiliate links, including links to Amazon products. This means that we may receive a commission if you click on the link and make a purchase from the affiliate website.
            </p>
            <p>
              When you use these links, the price you pay remains the same. However, we may receive a percentage of the sale or other compensation from the website to which you are directed.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px', color: '#374151' }}>No Endorsement</h2>
            <p>
              The presence of affiliate links on our site does not constitute an endorsement of the linked website or its products by Sellers Arena Inc. DBA Seller Synapse or RoastMyListing.ai. We only recommend products that we believe will provide value to our users.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px', color: '#374151' }}>Free to Paid Service Disclosure</h2>
            <p>
              While RoastMyListing.ai is currently offered as a free service, we reserve the right to convert to a paid model at any time if the current business model becomes unsustainable. We will provide notice of such changes through our website or via email if you've signed up for notifications.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px', color: '#374151' }}>No Earnings Guarantees</h2>
            <p>
              The information provided on RoastMyListing.ai is for general informational and educational purposes only. We make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability of the information, products, services, or related graphics contained on our website for any purpose.
            </p>
            <p>
              Any reliance you place on such information is strictly at your own risk. In no event will we be liable for any loss or damage, including but not limited to, indirect or consequential loss or damage, or any loss or damage whatsoever arising from loss of data or profits arising out of, or in connection with, the use of our website.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px', color: '#374151' }}>Amazon Disclaimer</h2>
            <p>
              RoastMyListing.ai is a participant in the Amazon Services LLC Associates Program, an affiliate advertising program designed to provide a means for sites to earn advertising fees by advertising and linking to Amazon.com.
            </p>
            <p>
              Amazon, the Amazon logo, AmazonSupply, and the AmazonSupply logo are trademarks of Amazon.com, Inc. or its affiliates. As an Amazon Associate, we earn from qualifying purchases.
            </p>
            <p>
              RoastMyListing.ai is not endorsed by, directly affiliated with, maintained, authorized, or sponsored by Amazon. All product and company names are the registered trademarks of their original owners.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px', color: '#374151' }}>Contact Information</h2>
            <p>
              If you have any questions about this disclaimer, please contact us at support@sellersarena.com.
            </p>
          </div>
        </div>
      </div>
    </HelmetProvider>
  );
};

export default EarningsDisclaimer;
